import { MARKET_STATE } from "@abios/abios-ts-sdk"

// These are the states that should be listed and showed to the user
export const ALLOWED_STATES_LIST = [
  MARKET_STATE.OPEN,
  MARKET_STATE.SUSPENDED,
  MARKET_STATE.SETTLED,
]
